import { Scrollbars } from 'rc-scrollbars';
import { useRef, useEffect, Children, cloneElement } from 'react';

export default function Scrollable({
    maxHeight = null, 
    maxItems = 0,
    itemHeight = 0,
    spacing = 0,
    children,
    className
}) {
    const itemsRef = useRef([]);

    const height = (maxItems * itemHeight) + (maxItems * spacing);

    // const childrenCount = Children.count(children);

    // useEffect(() => {
    //     itemsRef.current = itemsRef.current.slice(0, childrenCount);

    //     console.log(itemsRef.current);
    //  }, [ childrenCount ]);

    return <Scrollbars 
        autoHide={false}
        thumbMinSize={40}
        autoHeight
        autoHeightMax={maxHeight || height}
        classes={{
            trackVertical: 'scrollbar__vertical',
            thumbVertical: 'scrollbar__thumb'
        }}
        className={`activity-list__inner scrollbar ${className}`} 
        renderTrackHorizontal={() => <div style={{ display: 'none' }}></div>}
    >
        {/* { Children.map(children, (child, index) => cloneElement(child, { key: index, ref: el => itemsRef.current[index] = el } )) } */}
        { children }
    </Scrollbars>
}